import { Link } from 'react-router-dom';
import { useAuth } from '../../api/auth';
import { ThemeToggle } from '../../components/Theme';
import { Brand } from '../../components/Brand';
import { RequestAccessButton } from './RequestAccessButton';
export function LandingHeader() {
  const { user } = useAuth();
  return (
    <header className="wf-header">
      <Brand />
      <nav aria-label="Landing sections" className="wf-header__nav">
        <a href="#capabilities">Capabilities</a>
        <a href="#how-it-works">How it works</a>
        <a href="#early-access">For teams</a>
      </nav>
      <div className="wf-header__actions">
        <ThemeToggle />
        <RequestAccessButton />
        <Link className="wf-header__signin" to={user ? '/dashboard' : '/login'}>
          {user ? 'Open dashboard' : 'Sign In'}
        </Link>
      </div>
    </header>
  );
}
